import "../css/Header.css";
import { useState, useContext, useEffect } from 'react';
import { Flex } from "antd";
import { getFromLocalStorage } from "../utils/localStorage";
import useMediaItem from "../utils/useMediaItem";
import ButtonComp from "./ButtonComp";
import Navbar from "./Navbar";
import MobileMenu from "./MobileMenu";
import useIsMobile from '../utils/isMobile';
import { LangContext } from "../utils/LanguageProvider";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import { login, contactUs } from "../langs/buttons"
import { 
  obtainGclid,
  obtainUtmSource,
  obtainUtmMedium,
  obtainUtmCampaign,
  obtainUtmTerm,
  obtainUtmContent
} from "../utils/utmHelpers"
import LanguageBtn from "./LanguageSelect";

const GetLogo = ({lang}) => {
  let { loading, data } = useMediaItem('logo');
  if (!data) {
    data = getFromLocalStorage('logo');
  }

  if (loading && !data) return <p></p>;  
  return (
    <a href={`/${lang}`}>
      <img loading="lazy" src={setImageAbsoluteUrl(data?.mediaItemBy?.mediaItemUrl)} alt={data?.mediaItemBy?.title} className="logo" />
    </a>
  );
};

const HeaderComp = () => {
  const isMobile = useIsMobile();
  const cacheKey = "menuData";
  const { lang } = useContext(LangContext);

  const [menuTree, setMenuTree] = useState(() => {
    const cachedMenu = getFromLocalStorage(cacheKey);
    return cachedMenu ? cachedMenu : [];
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const contactForm = (lang) => {
    let contact
    if (lang === 'es') {
      contact = 'contacto'
    } else if (lang === 'en') {
      contact = 'contact'
    } else {
      contact = 'contato'
    }
    return contact
  }

  useEffect(() => {
    obtainGclid();
    obtainUtmSource();
    obtainUtmMedium();
    obtainUtmCampaign();
    obtainUtmTerm();
    obtainUtmContent();
  }, [])

  return (
    <>
      <Flex className={`header ${isMenuOpen ? "show" : ""}`}>
        <GetLogo cacheKey={cacheKey} menuTree={menuTree} setMenuTree={setMenuTree} lang={lang} />
        {!isMobile && (
          <>
            <Navbar menu={menuTree} lang={lang}/>
            <div className="header-buttons">
              <LanguageBtn/>
              {/* LOGIN */}
              <ButtonComp title={login[lang]} url={'https://shops.payretailers.com/login'} classStyle={`login-btn ${isMenuOpen ? "show" : ""} button-empty-sm-500`} />
              {/* CONTACT */}
              <ButtonComp title={contactUs[lang]} url={`/${lang}/${contactForm(lang)}`} classStyle={'header-contact-btn button-yellow-sm-500'} />
            </div>
          </>
        )}
        {isMobile && (
          <MobileMenu menu={menuTree} lang={lang} GetLogo={GetLogo} LanguageBtn={LanguageBtn} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen}/>
        )}
      </Flex>
    </>
  );
};

export default HeaderComp;
